import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

// antd
import {
    Col,
    Row,
    Typography,
    Avatar,
    Tooltip,
    Space,
    Popover,
    Select as NewSelect,
    message,
    Empty,
    theme,
    Drawer,
    Input,
    Button as AntButton,
    Divider,
} from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { Icon } from '@iconify/react'

// slices
import { projectsState } from '../projects/projects.slice'
import {
    getSubTaskList,
    switchFormModalSubTask,
    taskById,
    taskCreate,
    taskList,
    taskUpdate,
    tasksState,
} from './tasks.slice'
import { loginState } from '../login/login.slice'

// components
import Button from '../../components/button/button'

// styles
import styles from './tasks.module.css'

// assets
import {
    DeleteIcon,
    EditIcon,
    EllipsisIcon,
    SubTaskIcon,
    TaskLinkIcon,
} from '../../assets/icons'

// routes
import { PRIVATE_ROUTES } from '../../routes'

// sub Task Drawer
import SubTaskDrawerForm from './subTaskDrawerForm.index'

// helpers
import {
    addPermissionCheck,
    deletePermissionCheck,
    viewFieldCheck,
} from '../../helpers/permissionCheck'
import { formatTitle } from '../../helpers/formatTitle'
import { Image } from 'antd/es'
import StatusSelector from './components/statusSelector'
import { getInitials } from '../../utils/commonUtils'
import AssigneeSelectPopover from './components/assigneeSelector'

const SubTaskSection = ({
    assigneeList,
    epicsOption,
    taskTypeOption,
    sprintsOption,
    swimLanesOptionTask,
}) => {
    const { Text, Title } = Typography

    const { Option } = NewSelect

    const { useToken } = theme

    const { token } = useToken()

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { params } = useParams()

    const { currentProjectData } = useSelector(projectsState)
    const {
        pageLimit,
        skipPage,
        selectedTask,
        subTasksList,
        formSubTask,
        selectedSubTask,
    } = useSelector(tasksState)
    const { userProfile } = useSelector(loginState)

    const [selected, setSelected] = useState({})
    const [swimLanesOption, setSwimLanesOption] = useState([])
    const [createChild, setCreateChild] = useState(false)
    const [subTaskLoadingButton, setSubTaskLoadingButton] = useState(false)
    const [titleValue, setTitleValue] = useState('')
    const [drawerWidth, setDrawerWidth] = useState(window.innerWidth * 0.36)
    const [deleteCheck, setDeleteCheck] = useState(false)
    const [taskID, setTaskID] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [open, setOpen] = useState(false)

    async function subTaskListGet() {
        await dispatch(
            getSubTaskList({
                skip: 0,
                limit: 10,
                parentId: selectedTask?._id,
            })
        )
    }

    // UPDATE TASK ASSIGNEE
    async function updateTaskAssignee(value, Id, name) {
        let assigneeIdValue = {
            assigneeId: value,
        }
        let statusValue = {
            status: value,
        }

        const result = await dispatch(
            taskUpdate({
                updateTask: name === 'status' ? statusValue : assigneeIdValue,
                _id: Id,
            })
        )
        const data = result?.payload?.data
        if (data) {
            const { success } = data
            if (success) {
                subTaskListGet()
                await dispatch(
                    taskList({
                        limit: pageLimit,
                        skip: skipPage,
                        filter: {
                            projectId: JSON.parse(
                                localStorage.getItem('currentProject')
                            )?.id,
                            sprintId: JSON.parse(
                                localStorage.getItem('currentSprint')
                            )?.id,
                        },
                    })
                )
            } else {
                message.error('Something went wrong, try again later.')
            }
        }
    }

    // CREATE SUB TASK
    const createChildTask = async () => {
        setSubTaskLoadingButton(true)
        const result = await dispatch(
            taskCreate({
                title: titleValue,
                parent: selectedTask?._id,
                projectId: JSON.parse(localStorage.getItem('currentProject'))
                    ?.id,
                sprintId: selectedTask?.sprintId[0]?._id,
            })
        )
        const data = result?.payload?.data
        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                setSubTaskLoadingButton(false)
                subTaskListGet()
                setSelected()
                dispatch(
                    taskList({
                        limit: pageLimit,
                        skip: skipPage,
                        filter: {
                            projectId: JSON.parse(
                                localStorage.getItem('currentProject')
                            )?.id,
                            sprintId: JSON.parse(
                                localStorage.getItem('currentSprint')
                            )?.id,
                        },
                    })
                )
                message.success(checkMessage)
                setCreateChild(false)
            } else {
                setSubTaskLoadingButton(false)
                setSelected()
                setCreateChild(false)
                if (checkMessage) {
                    message.error(checkMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    // VIEW SUB TASK
    async function viewSubTask(st) {
        dispatch(switchFormModalSubTask({ open: true }))
        const result = await dispatch(taskById({ _id: st?._id }))
        const data = result?.payload?.data
        if (data) {
            const { success } = data
            if (success) {
                setSelected(data?.data[0])
                // setSubTaskFormShow(true)
            } else {
                message.error('Something went wrong, try again later.')
            }
        }
    }

    // GET SWIMLANES
    useEffect(() => {
        if (currentProjectData?.swimlanes?.length > 0) {
            const options = currentProjectData?.swimlanes.map((data) => {
                return {
                    label: data?.name,
                    value: data?._id,
                }
            })
            setSwimLanesOption(options)
        }
        if (currentProjectData?.taskType?.length > 0) {
            const options = currentProjectData?.taskType.map((data) => {
                return {
                    label: data,
                    value: data,
                }
            })
            // setTaskTypeOption(options)
        }
    }, [currentProjectData])

    useEffect(() => {
        const handleResize = () => setDrawerWidth(window.innerWidth * 0.36)
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const dropDownIcon = [
        {
            title: deletePermissionCheck('tasks', userProfile) ? (
                'Delete'
            ) : (
                <Tooltip
                    arrow={false}
                    placement="bottom"
                    title="You don't have permission to delete task"
                >
                    <Text
                        style={{
                            margin: '0px',
                        }}
                    >
                        Delete
                    </Text>
                </Tooltip>
            ),
            icon: <DeleteIcon />,
            onClick: (_id) => {
                if (deletePermissionCheck('tasks', userProfile)) {
                    setDeleteCheck(true)
                    setTaskID(_id)
                    setDeleteModal(true)
                }
            },
        },
    ]
    const CopyTextButton = ({ text }) => {
        const handleCopy = () => {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    message.success('Link copied!')
                })
                .catch(() => {
                    message.error('Failed to copy link')
                })
        }

        return (
            <Tooltip title="Copy task link">
                <Icon
                    icon="solar:link-outline"
                    height={20}
                    width={20}
                    onClick={handleCopy}
                    style={{
                        cursor: 'pointer',
                    }}
                />
            </Tooltip>
        )
    }

    const dropDownContent = (id) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '8px',
                    }}
                >
                    {dropDownIcon?.length > 0 &&
                        dropDownIcon.map((data) => (
                            <Row
                                style={{
                                    cursor: 'pointer',
                                }}
                                align={'middle'}
                                onClick={() => data?.onClick(id)}
                            >
                                <div
                                    style={{
                                        marginRight: '10px',
                                    }}
                                >
                                    {data?.icon}
                                </div>
                                <Text className="sub-title">{data?.title}</Text>
                            </Row>
                        ))}
                </div>
            </>
        )
    }

    const handleOpenChange = (newOpen) => {
        setOpen(newOpen)
        if (newOpen === true) {
            setDeleteCheck(true)
        } else {
            setDeleteCheck(false)
        }
    }

    const onCloseTaskDrawer = () => {
        dispatch(switchFormModalSubTask({ open: false }))
        if (params?.search.includes('taskId')) {
            navigate(PRIVATE_ROUTES.tasks)
        }
    }

    return (
        <>
            <div>
                {(subTasksList?.length > 0 || createChild) && (
                    <Row
                        justify={'space-between'}
                        align={'middle'}
                        style={{
                            padding: '0px 20px',
                        }}
                    >
                        <Title
                            level={4}
                            style={{
                                fontSize: '17px',
                            }}
                        >
                            Sub tasks
                        </Title>
                        <Divider
                            style={{
                                margin: '13px 0px 13px 0px',
                            }}
                        />
                    </Row>
                )}
                {viewFieldCheck('tasks', 'subTask', userProfile) &&
                    subTasksList?.length > 0 && (
                        // !subTaskFormShow &&
                        <div>
                            {subTasksList?.length > 0 &&
                                subTasksList.map((st) => (
                                    <div
                                        style={{
                                            padding: '0px 15px',
                                        }}
                                    >
                                        <Row
                                            align={'middle'}
                                            justify={'space-between'}
                                            className={styles.viewSubTaskList}
                                            style={{
                                                flexFlow: 'row nowrap',
                                            }}
                                        >
                                            <Col>
                                                <Row
                                                    gutter={12}
                                                    align={'middle'}
                                                    style={{
                                                        flexFlow: 'row nowrap',
                                                    }}
                                                >
                                                    <Col>
                                                        <Text
                                                            style={{
                                                                color: token
                                                                    .colorPalette
                                                                    .baseColor
                                                                    .tertiary,
                                                                cursor: 'pointer',
                                                                fontWeight: 600,
                                                            }}
                                                            onClick={() => {
                                                                viewSubTask(st)
                                                            }}
                                                        >
                                                            {st?.taskKey}
                                                        </Text>
                                                    </Col>
                                                    <Col>
                                                        <div
                                                            style={{
                                                                fontSize: 14,
                                                                fontWeight: 500,
                                                                wordBreak:
                                                                    'break-word',
                                                            }}
                                                        >
                                                            {formatTitle(
                                                                st?.title,
                                                                20
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row
                                                    gutter={12}
                                                    align={'middle'}
                                                    style={{
                                                        flexFlow: 'row nowrap',
                                                    }}
                                                >
                                                    <Col>
                                                        {/* <NewSelect
                                                        placeholder="Select a Status"
                                                        onChange={(event) => {
                                                            if (
                                                                event !==
                                                                st?.status
                                                            ) {
                                                                updateTaskAssignee(
                                                                    event,
                                                                    st?._id
                                                                )
                                                            }
                                                        }}
                                                        className={[
                                                            styles.statusSelect,
                                                            'arrowStatusSelectSubTask',
                                                        ]}
                                                        defaultValue={
                                                            st?.status
                                                        }
                                                        style={{
                                                            padding: '0px 0px',
                                                        }}
                                                        showArrow={false}
                                                    >
                                                        {swimLanesOption?.length >
                                                            0 &&
                                                            swimLanesOption.map(
                                                                (data) => (
                                                                    <Option
                                                                        value={
                                                                            data?.label
                                                                        }
                                                                        key={
                                                                            data?.label
                                                                        }
                                                                    >
                                                                        {
                                                                            data?.label
                                                                        }
                                                                    </Option>
                                                                )
                                                            )}
                                                    </NewSelect> */}
                                                        <StatusSelector
                                                            statusType={
                                                                swimLanesOption
                                                            }
                                                            name="status"
                                                            updateDetails={(
                                                                name,
                                                                value
                                                            ) => {
                                                                updateTaskAssignee(
                                                                    value?.value,
                                                                    st?._id,
                                                                    name
                                                                )
                                                            }}
                                                            value={{
                                                                label: swimLanesOption?.find(
                                                                    (item) =>
                                                                        item?.value ===
                                                                        st?.status
                                                                )?.label,
                                                                value: st?.status,
                                                            }}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <AssigneeSelectPopover
                                                            searchable
                                                            assigneeList={
                                                                assigneeList
                                                            }
                                                            selectedAssignee={
                                                                st
                                                                    ?.assigneeId?.[0]
                                                            }
                                                            // selectedAssignee={
                                                            //     assigneeList?.length >
                                                            //         0
                                                            //         ? assigneeList.find(
                                                            //             (
                                                            //                 data
                                                            //             ) =>
                                                            //                 data?.value ===
                                                            //                 st?.assigneeId[0]?._id
                                                            //         )
                                                            //         : null
                                                            // }
                                                            onChange={(
                                                                selected
                                                            ) =>
                                                                updateTaskAssignee(
                                                                    selected,
                                                                    st._id,
                                                                    'assigneeId'
                                                                )
                                                            }
                                                        />

                                                        {/* <Popover
                                                            content={
                                                                <div>
                                                                    {assigneeList
                                                                        ?.filter(
                                                                            (
                                                                                data
                                                                            ) =>
                                                                                data?.value !==
                                                                                st
                                                                                    ?.assigneeId?.[0]
                                                                                    ?._id
                                                                        )
                                                                        .map(
                                                                            (
                                                                                option
                                                                            ) => (
                                                                                <Row
                                                                                    key={
                                                                                        option?.value
                                                                                    }
                                                                                    className={
                                                                                        styles.popOverClick
                                                                                    }
                                                                                    style={{
                                                                                        cursor: 'pointer',
                                                                                        padding: 10,
                                                                                        borderRadius: 5,
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        updateTaskAssignee(
                                                                                            option?.value,
                                                                                            st?._id,
                                                                                            'assigneeId'
                                                                                        )
                                                                                    }
                                                                                    align={
                                                                                        'middle'
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            display:
                                                                                                'flex',

                                                                                            columnGap: 8,
                                                                                            alignItems:
                                                                                                'center',
                                                                                        }}
                                                                                    >
                                                                                        {option?.profilePicture ? (
                                                                                            <Image
                                                                                                src={
                                                                                                    option?.profilePicture
                                                                                                }
                                                                                                height="30px"
                                                                                                width="30px"
                                                                                                preview={
                                                                                                    false
                                                                                                }
                                                                                                style={{
                                                                                                    borderRadius:
                                                                                                        '50%',
                                                                                                    objectFit:
                                                                                                        'cover', // <-- key line
                                                                                                    display:
                                                                                                        'block',
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            <Avatar
                                                                                                style={{
                                                                                                    backgroundColor:
                                                                                                        'rgb(0 10 129 / 25%)',
                                                                                                    height: 30,
                                                                                                    width: 30,
                                                                                                    cursor: 'pointer',
                                                                                                }}
                                                                                            >
                                                                                                {getInitials(
                                                                                                    option?.label
                                                                                                )}
                                                                                            </Avatar>
                                                                                        )}
                                                                                        <div
                                                                                            style={{
                                                                                                display:
                                                                                                    'flex',
                                                                                                flexDirection:
                                                                                                    'column',
                                                                                            }}
                                                                                        >
                                                                                            <Text
                                                                                                style={{
                                                                                                    fontSize: 14,
                                                                                                }}
                                                                                            >
                                                                                                {
                                                                                                    option?.label
                                                                                                }
                                                                                            </Text>

                                                                                            <Text
                                                                                                style={{
                                                                                                    color: token
                                                                                                        .colorPalette
                                                                                                        .textColor
                                                                                                        .secondary,
                                                                                                }}
                                                                                            >
                                                                                                {
                                                                                                    option?.email
                                                                                                }
                                                                                            </Text>
                                                                                        </div>
                                                                                    </div>
                                                                                </Row>
                                                                            )
                                                                        )}
                                                                </div>
                                                            }
                                                            styles={{
                                                                body: {
                                                                    maxHeight:
                                                                        '200px',
                                                                    overflowY:
                                                                        'auto',
                                                                    padding: 5,
                                                                },
                                                            }}
                                                            trigger="click"
                                                            arrow={false}
                                                            placement="bottom"
                                                        >
                                                            <Tooltip
                                                                title={
                                                                    st
                                                                        ?.assigneeId
                                                                        ?.length >
                                                                    0
                                                                        ? st
                                                                              ?.assigneeId[0]
                                                                              ?.name
                                                                        : 'Assign this subtask'
                                                                }
                                                            >
                                                                {st?.assigneeId
                                                                    ?.length >
                                                                0 ? (
                                                                    st
                                                                        ?.assigneeId[0]
                                                                        ?.profilePicture ? (
                                                                        <Image
                                                                            src={
                                                                                st
                                                                                    ?.assigneeId[0]
                                                                                    ?.profilePicture
                                                                            }
                                                                            height="28px"
                                                                            width="28px"
                                                                            preview={
                                                                                false
                                                                            }
                                                                            style={{
                                                                                borderRadius:
                                                                                    '50%',
                                                                                cursor: 'pointer',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Avatar
                                                                            size="small"
                                                                            style={{
                                                                                backgroundColor:
                                                                                    token
                                                                                        .colorPalette
                                                                                        .baseColor
                                                                                        .tertiary,
                                                                                cursor: 'pointer',
                                                                                fontSize:
                                                                                    '12px',
                                                                            }}
                                                                        >
                                                                            {getInitials(
                                                                                st
                                                                                    ?.assigneeId[0]
                                                                                    ?.name
                                                                            )}
                                                                        </Avatar>
                                                                    )
                                                                ) : (
                                                                    <Icon
                                                                        icon="lets-icons:user-cicrle-light"
                                                                        width={
                                                                            28
                                                                        }
                                                                        height={
                                                                            28
                                                                        }
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    />
                                                                )}
                                                            </Tooltip>
                                                        </Popover> */}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Divider
                                            style={{
                                                margin: '10px 0px 10px 0px',
                                            }}
                                        />
                                    </div>
                                ))}
                        </div>
                    )}
                {createChild && (
                    <Row
                        align={'middle'}
                        style={{
                            width: '100%',
                            marginTop: '0px',
                        }}
                        justify={'space-between'}
                        className={styles.subTaskList}
                    >
                        <Input
                            variant={'borderless'}
                            style={{
                                maxWidth: '50%',
                                paddingLeft: '0px',
                            }}
                            disabled={subTaskLoadingButton}
                            onChange={(e) => {
                                setTitleValue(e.target.value.trimStart())
                            }}
                            placeholder="Enter Title"
                        />
                        <Row
                            align={'middle'}
                            style={{
                                columnGap: '10px',
                            }}
                        >
                            <Button
                                props={{
                                    buttonType: 'text',
                                    onClick: () => setCreateChild(false),
                                    style: {
                                        width: 'auto',
                                    },
                                    className: 'createTaskSprintBoard',
                                    icon: (
                                        <div className="createTaskSprintBtn">
                                            <Icon
                                                icon="maki:cross"
                                                height={10}
                                                width={10}
                                                color={
                                                    token.colorPalette.baseColor
                                                        .tertiary
                                                }
                                            />
                                        </div>
                                    ),
                                }}
                            />
                            <Button
                                props={{
                                    text: 'Save',
                                    onClick: () => {
                                        if (
                                            titleValue?.length > 0 &&
                                            titleValue?.length <= 400
                                        ) {
                                            createChildTask()
                                        } else if (titleValue?.length > 400) {
                                            message.error(
                                                'SubTask Title should be maximum 400 characters long'
                                            )
                                        } else {
                                            message.error(
                                                'SubTask Title should be required'
                                            )
                                        }
                                    },
                                    loadingButton: subTaskLoadingButton,
                                    style: {
                                        padding: '2px 23px',
                                        fontSize: '14px',
                                    },
                                }}
                            />
                        </Row>
                    </Row>
                )}

                {addPermissionCheck('tasks', userProfile) && (
                    <div
                        style={{
                            padding: '0px 20px',
                        }}
                    >
                        <AntButton
                            onClick={() => {
                                setCreateChild(!createChild)
                            }}
                            type="default"
                            style={{
                                backgroundColor: 'transparent',
                                color: '#000000',
                                padding: '8px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            className={styles.addSubTaskButton}
                            icon={
                                <Icon
                                    icon="ic:baseline-plus"
                                    width={18}
                                    height={18}
                                    style={{
                                        display: 'flex',
                                    }}
                                />
                            }
                        >
                            Add subtask
                        </AntButton>
                    </div>
                )}
            </div>
            <Drawer
                placement="right"
                width={drawerWidth}
                style={{
                    height: '100vh',
                }}
                title={
                    <Row
                        justify="end"
                        style={{
                            columnGap: '15px',
                        }}
                        align="center"
                    >
                        {selectedSubTask && (
                            <Popover
                                content={dropDownContent(selectedSubTask?._id)}
                                trigger="click"
                                placement="bottom"
                                open={open}
                                overlayInnerStyle={{
                                    padding: '10px',
                                }}
                                arrow={false}
                                onOpenChange={handleOpenChange}
                            >
                                <div
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                >
                                    <EllipsisIcon />
                                </div>
                            </Popover>
                        )}

                        {selectedSubTask && (
                            <CopyTextButton
                                text={`${window.location.origin}${window.location.pathname}?subTaskId=${selectedSubTask?._id}?perentId=${selectedSubTask?.parentTask[0]?._id}`}
                            />
                        )}

                        <Tooltip title="Close" placement="top">
                            <Icon
                                icon="ph:arrow-line-right"
                                onClick={onCloseTaskDrawer}
                                height={20}
                                width={20}
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        </Tooltip>
                    </Row>
                }
                styles={{
                    body: {
                        padding: '0px',
                        scrollbarColor: 'auto',
                        overflowX: 'hidden',
                    },
                    wrapper: {
                        scrollbarColor: 'auto',
                    },
                    content: {
                        scrollbarColor: 'auto',
                    },
                }}
                rootClassName="taskHeader"
                onClose={onCloseTaskDrawer}
                closeIcon={null}
                open={formSubTask}
            >
                <SubTaskDrawerForm
                    onCancel={() => {
                        setSelected()
                        // setSubTaskFormShow(false)
                    }}
                    onCreateChild={() => {
                        setSelected()
                        // subTaskListGet()
                        // setSubTaskFormShow(false)
                    }}
                    // parentValues={values}
                    // selectedSubTask={selected}
                    // subTaskFormShow={subTaskFormShow}
                    assigneeList={assigneeList}
                    swimLanes={swimLanesOptionTask}
                    taskType={taskTypeOption}
                    sprints={sprintsOption}
                    epics={epicsOption}
                />
            </Drawer>
        </>
    )
}

export default SubTaskSection
